import { t } from '../../../i18n.es.js';
import React from 'react';
import { styled, Row, Col, Button } from '@teko/ui';
import { JDDropdown } from '../../../Common/JDDropdown/JDDropdown.es.js';

const Title = styled.div`
  font-weight: 600;
  margin-left: -0.5rem;
  margin-right: -0.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
`;
const StyledRow = styled(Row)`
  margin-bottom: 0.25rem;
  margin-left: 0;
  margin-right: 0;
  > * {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
`;
const DropdownOption = styled(JDDropdown)`
  max-width: 19%;
  margin-right: 0.5rem;
`;
const AdvancedFilterRow = ({
  filters,
  onClickOption,
  activeValues = []
}) => {
  return /* @__PURE__ */ React.createElement(StyledRow, null, /* @__PURE__ */ React.createElement(Col, {
    col: 1.5
  }, /* @__PURE__ */ React.createElement(Title, null, t("B\u1ED9 l\u1ECDc n\xE2ng cao"))), /* @__PURE__ */ React.createElement(Col, {
    col: 10.5
  }, filters.slice(5, 10).map((filter, index) => {
    return /* @__PURE__ */ React.createElement(DropdownOption, {
      count: activeValues.filter((value) => value.filterCode === filter.code).length,
      text: filter.name,
      key: index
    }, /* @__PURE__ */ React.createElement(React.Fragment, null, filter.options.map((option, index2) => /* @__PURE__ */ React.createElement(Button, {
      key: index2,
      link: true,
      onClick: () => {
        if (onClickOption) {
          onClickOption(option);
        }
      },
      variant: activeValues.findIndex((activatedValue) => activatedValue.optionCode === option.optionCode) !== -1 ? "primary" : "normal"
    }, option.optionName))));
  })));
};

export { AdvancedFilterRow };
